const PageNotFound = () => {
    return ( 
        <div className="text-center h-[100vh] mt-[200px]">
            <h1 className="text-9xl">Page Not found</h1>
        </div>
     );
}
 
export default PageNotFound;